// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 2:10 AM
 */
import React from 'react';
import {Collapse, DropdownItem, DropdownMenu, DropdownToggle, Nav, Navbar, NavbarBrand, NavbarToggler, UncontrolledDropdown} from "reactstrap";
import UserIcon from 'react-icons/lib/fa/user';
import {Link} from "react-router-dom";
import '../css/style.css';
import logo from '../images/hktdc_logo.png';
import {PHOTO_EBADGE_QUERY_PAGE_TITLE} from "./ebadge/photo/PhotoEBadgeQueryPage";
import {QUERY_PAGE_PAGE_TITLE} from "./QueryPage";
import type {RoleConfig} from "../types/utilityTypes";
import { BADGE_GROUP_CSV_JOB_PAGE_TITLE, BADGE_GROUP_CSV_JOB_PAGE_URL } from '../containers/BadgeGroupCsvJobContainer';

export type HeaderBarDispatchProps = {
    openMenu: () => any,
    closeMenu: () => any,
    logout: () => any
}

export type HeaderBarStateProps = {
    open: boolean,
    name: string,
    roleConfig: RoleConfig
}

type HeaderBarOwnProps = {
    title: string
}

type HeaderBarProps = HeaderBarStateProps & HeaderBarDispatchProps & HeaderBarOwnProps;

function HeaderBar(props: HeaderBarProps) {

    return (
        <Navbar light expand={"md"} className="border-bottom border-dark p-0">
            <NavbarToggler onClick={() => {
                props.open ? props.closeMenu() : props.openMenu()
            }} className="m-2"/>
            <NavbarBrand tag={Link} to="/query/ebadges" className="mr-auto pl-3">
                <img id="logo" src={logo} className="d-none d-md-inline mr-3" alt='logo'/>
            </NavbarBrand>
            <Collapse isOpen={props.open} navbar>
                <Nav className="ml-2 mr-auto" navbar>
                    <UncontrolledDropdown nav inNavbar right="true">
                        <DropdownToggle nav caret color="light">
                            {props.title}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem tag={Link} to="/query/ebadges">{QUERY_PAGE_PAGE_TITLE}</DropdownItem>
                            {
                                props.roleConfig.allowPhotoEBadgeManagement &&
                                <DropdownItem tag={Link} to="/photo/query">{PHOTO_EBADGE_QUERY_PAGE_TITLE}</DropdownItem>
                            }
                            <DropdownItem tag={Link} to={BADGE_GROUP_CSV_JOB_PAGE_URL}>{BADGE_GROUP_CSV_JOB_PAGE_TITLE}</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
                <Nav className="ml-2" navbar>
                    <span className="border-left border-dark d-none d-md-inline"/>
                    <UncontrolledDropdown nav inNavbar right="true">
                        <DropdownToggle nav caret>
                            <UserIcon/> {props.name}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => {
                                props.logout()
                            }}>
                                Logout
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
            </Collapse>
        </Navbar>
    );
}

export default HeaderBar;


// WEBPACK FOOTER //
// ./src/components/HeaderBar.js